import { createContext } from 'react';
const TourContext = /*#__PURE__*/createContext({
  tour: undefined
});
export default TourContext;